<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Vendor List</span>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Shop Name</th>
                <th>Delivery Area</th>
                <th>User Details</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vendor, index) in vendors" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ vendor.shopDetails.name }}</td>
                <td>
                  {{ vendor.shopDetails.address.firstLine }} , <br />
                  {{ vendor.shopDetails.address.city }} ,
                  {{ vendor.shopDetails.address.state }}
                </td>
                <td>
                  <tr>
                    <td>{{ vendor.personalDetails.name }}</td>
                    <td>{{ vendor.personalDetails.number }}</td>
                    <td>{{ vendor.personalDetails.email }}</td>
                  </tr>
                </td>

                <td>
                  <b-badge variant="danger" v-if="vendor.status == 0"
                    >Not Active</b-badge
                  >
                  <b-badge variant="warning" v-else-if="vendor.status == 1"
                    >Active</b-badge
                  >
                  <b-badge variant="success" v-else-if="vendor.status == 2"
                    >Verified</b-badge
                  >
                </td>
                <td>
                  <span v-if="vendor.status == 0" class="text-center">
                    <button
                      class="btn btn-sm btn-success"
                      @click="UpdateVendor(vendor, 1)"
                      v-b-tooltip.hover
                      title="Approve"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                    &nbsp;
                  </span>
                  <span v-else-if="vendor.status != 0">
                    <button
                      class="btn btn-sm btn-danger"
                      @click="UpdateVendor(vendor, 0)"
                      v-b-tooltip.hover
                      title="Disapprove"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                    &nbsp;
                  </span>
                  <span v-if="vendor.status == 1">
                    <button
                      class="btn btn-sm btn-success"
                      @click="Vendorverification(vendor)"
                      v-b-tooltip.hover
                      title="Verify"
                    >
                      Verify
                    </button>
                    &nbsp;
                  </span>
                </td>
                <b-modal
                  v-model="verify_vendor_model"
                  title="Verify Vendor"
                  hide-footer=""
                >
                  <div v-if="addProductloading">
                    <div class="col-md-12 text-center">
                      <sweetalert-icon :icon="loadingType" />
                    </div>
                    <div class="col-md-12 text-center">
                      <h3 class="text-center">{{ loadingMessage }}</h3>
                    </div>
                  </div>
                  <b-form v-on:submit.prevent="VerifyVendor" v-else>
                    <table class="table">
                      <thead>
                        <th>#</th>
                        <th>Name</th>
                        <th>Number</th>
                        <td>Status</td>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(doc, docindex) in verifyVendorDoc"
                          :key="docindex"
                        >
                          <td>
                            {{ ++docindex }}
                          </td>
                          <td>
                            {{ doc.name }}
                          </td>
                          <td>{{ doc.number }}</td>
                          <td>
                            <b-badge variant="success" v-if="doc.verify == true"
                              >Verified</b-badge
                            >
                            <b-badge variant="danger" v-else>
                              Not Verified
                            </b-badge>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button
                      type="submit"
                      class="btn btn-warning btn-lg text-center pull-right"
                    >
                      Verify
                    </button>
                  </b-form>
                </b-modal>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      loading: false,
      dataTable: null,
      loadingType: "",
      loadingMessage: "",
      addProductloading: false,
      verify_vendor_model: false,
      vendors: [],
      newVendor: {
        deliveryArea: 0.2,
        payment: {
          bankDetails: { ifsc: "SBIO083", name: "SBI", number: 79479797374 },
          history: {}
        },
        personalDetails: {
          email: "rahul@gmail.com",
          name: "Rahul",
          number: 7217626426
        },
        shopDetails: {
          address: {
            city: "Gr Noida",
            firstLine: "Choudhary Dairy",
            latlong: { _lat: 28.5378958, _long: 77.4374145 },
            pincode: 201301,
            state: "UP"
          },
          name: "KK Food"
        },
        vendor: true
      },
      verifyVendorDoc: [],
      verifyVendorId: "",
      add_vendor_model: false
    };
  },
  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.forDataTable();
        });
    },
    UpdateVendor(vendor, status) {
      let id = vendor.id;
      dbFs
        .collection("vendor")
        .doc(id)
        .update({
          status: status
        })
        .then(() => {
          console.log("Update");
        });
    },
    Vendorverification(vendor) {
      this.verifyVendorDoc = vendor.document;
      this.verifyVendorId = vendor.id;
      this.verify_vendor_model = true;
    },
    VerifyVendor() {
      this.addProductloading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Verifying Vendor";
      dbFs
        .collection("vendor")
        .doc(this.verifyVendorId)
        .update({
          status: 2
        })
        .then(() => {
          this.loadingType = "success";
          this.loadingMessage = "Vendor Verified";
          setTimeout(() => {
            this.verify_vendor_model = false;
            this.addProductloading = false;
            this.verifyVendorDoc = [];
            this.verifyVendorId = "";
          }, 2000);
        });
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    }
  }
};
</script>

<style scoped></style>
